import React from "react";
import { Select } from "antd";
import { ArcherContainer, ArcherElement } from "react-archer";
import { LeftCircleOutlined, RightCircleOutlined } from "@ant-design/icons";

const MatchingQuestionViewer = ({
  pairs = [],
  userAnswers = {},
  setUserAnswers = () => {},
  questionId,
  disabled = false
}) => {
  // Extraire toutes les réponses possibles (uniques) côté droit
  const rightOptions = [...new Set(pairs.map((p) => p.rightText))];

  // Mise à jour de la réponse sélectionnée
  const handleChange = (leftText, selectedRight) => {
    setUserAnswers((prev) => ({
      ...prev,
      [questionId]: {
        ...(prev[questionId] || {}),
        [leftText]: selectedRight,
      },
    }));
  };

  return (
    <div
      style={{
        background: "#fffbe6",
        padding: 30,
        borderRadius: 12,
        marginBottom: 30,
      }}
    >
      <ArcherContainer strokeColor="#52c41a" lineStyle="arrow">
        <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
          {pairs.map((pair, index) => {
            const selectedTarget = userAnswers[questionId]?.[pair.leftText];

            return (
              <div
                key={pair.id || index}
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 0.5fr 1fr auto",
                  alignItems: "center",
                  gap: 16,
                }}
              >
                {/* Partie gauche (question) avec flèche dynamique */}
                <ArcherElement
                  id={`left-${pair.leftText}`}
                  relations={
                    selectedTarget
                      ? [
                          {
                            targetId: `right-${selectedTarget}`,
                            sourceAnchor: "right",
                            targetAnchor: "left",
                          },
                        ]
                      : []
                  }
                >
                  <div
                    style={{
                      padding: "10px 12px",
                      border: "2px solid #52c41a",
                      background: "#f6ffed",
                      borderRadius: 8,
                    }}
                  >
                    <LeftCircleOutlined /> {pair.leftText}
                  </div>
                </ArcherElement>

                <div /> {/* Espace pour la flèche */}

                {/* Partie droite (réponse) */}
                <ArcherElement id={`right-${pair.rightText}`}>
                  <div
                    style={{
                      padding: "10px 12px",
                      border: "2px solid #1890ff",
                      background: "#e6f7ff",
                      borderRadius: 8,
                    }}
                  >
                    <RightCircleOutlined /> {pair.rightText}
                  </div>
                </ArcherElement>

                {/* Sélecteur de correspondance */}
                <Select
                  style={{ width: 160 }}
                  placeholder="Sélectionnez"
                  disabled={disabled}
                  value={userAnswers[questionId]?.[pair.leftText] || undefined}
                  onChange={(value) => handleChange(pair.leftText, value)}
                >
                  {rightOptions.map((opt, idx) => (
                    <Select.Option key={idx} value={opt}>
                      {opt}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            );
          })}
        </div>
      </ArcherContainer>
    </div>
  );
};

export default MatchingQuestionViewer;
